// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress--YtmY3","wave":"wave--MmAKK","menu":"menu--33E6x"};